module.exports = {"id":"164464","name":"Bradley Wright-Phillips","rating":"76","photo":"./data/images/photos/2/164464.png","club":{"name":"NY Red Bulls","logo":"./data/images/clubs/NYRedBulls.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BradleyWright-Phillips0.json
// module id = 634
// module chunks = 0